import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'propertyClass',
  standalone: true,
})
export class PropertyClassPipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }
}
